/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Fact_LengthInputs */

const en_services_fact_length = /** @type {(inputs: Services_Fact_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length`)
};

const pl_services_fact_length = /** @type {(inputs: Services_Fact_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas trwania`)
};

/**
* | output |
* | --- |
* | "Length" |
*
* @param {Services_Fact_LengthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_fact_length = /** @type {((inputs?: Services_Fact_LengthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Fact_LengthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_fact_length(inputs)
	return en_services_fact_length(inputs)
});